
import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import { FindAllLocationsQueryQuery, Location } from "../../../schemaTypes";

export const findAllLocationsQuery = gql`
  query FindAllLocationsQuery {
    findAllLocations {
      id
      district
      city
      streetName
      country
      postalCode
      landmark
      latitude
      longitude
      isArchive
      createdAt
      createdBy {
        id
        role
        admin {
          id
          level
          firstname
          lastname
        }
      }
    }
  }
`;

export const newLocationSubscription = gql`
  subscription NewLocationSubscription {
    newLocation {
      id
      district
      city
      streetName
      country
      postalCode
      landmark
      latitude
      longitude
      isArchive
      createdAt
      createdBy {
        id
        role
        admin {
          id
          level
          firstname
          lastname
        }
      }
    }
  }
`;

type NewLocationSubscriptionResult = {
  newLocation: Location;
};

export function useFindAllLocations() {
  const { data, loading, subscribeToMore } = useQuery<FindAllLocationsQueryQuery>(findAllLocationsQuery);

  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newLocationSubscription,
      updateQuery: (prev, { subscriptionData }: { subscriptionData: { data?: NewLocationSubscriptionResult } }) => {
        if (!subscriptionData.data) return prev;
        const prevLocations = Array.isArray(prev.findAllLocations)
          ? prev.findAllLocations.filter(Boolean)
          : [];
        return {
          ...prev,
          findAllLocations: [
            ...prevLocations,
            subscriptionData.data.newLocation
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore]);

  return {
    locations: data?.findAllLocations ?? [],
    loading
  };
}
